import { AbstractControlOptions } from '@angular/forms';

export interface ValidationResult { [validator: string]: string | boolean; }

export const UpdateOnChange: AbstractControlOptions = { updateOn: 'change' };
export const UpdateOnBlur: AbstractControlOptions = { updateOn: 'blur' };
export const UpdateOnSubmit: AbstractControlOptions = { updateOn: 'submit' };
